<template>
	<v-card flat>
		<v-card-text class="text-xs-left">
			<v-checkbox v-model="form.createLogin" label="Create a login for this employee"></v-checkbox>
            <div v-show="form.createLogin" class="ml-4">
                <password-input v-model="form.password" />
                <v-divider class="my-4"></v-divider>
                <v-checkbox v-model="form.notifyEmployee" label="Email login details to employee"></v-checkbox>
                <v-checkbox v-if="loggedInEmployee.isAdmin" v-model="form.isAdmin" label="Administrator privileges"></v-checkbox>
                <v-alert :value="form.isAdmin" color="warning" icon="warning" class="text-xs-left" outline>Administrators have full system access. Please grant this privilege with caution.</v-alert>
            </div>
		</v-card-text>
	</v-card>
</template>

<script>
	import PasswordInput from '@/components/common/PasswordInput';

	export default {
		components: {
			PasswordInput
		},
        props: {
            loggedInEmployee: {
                type: Object,
                required: true
            },
            loginDetails: {
                type: Object,
                default: () => ({
					createLogin: true,
                    notifyEmployee: true,
					password: '',
                    roles: []
				})
            }
        },
        watch: {
            formSerialised() {
                this.$emit("onUpdated", {
                    createLogin: this.form.createLogin,
                    notifyEmployee: this.form.createLogin ? this.form.notifyEmployee : false,
					password: this.form.createLogin ?  this.form.password : null,
                    roles: this.form.createLogin && this.form.isAdmin ? [ "admin" ] : []
                })
            }
        },
		data() {
			return {
				form: {
                    createLogin: this.loginDetails.createLogin,
                    notifyEmployee: this.loginDetails.notifyEmployee,
					password: this.loginDetails.password,
                    isAdmin: this.loginDetails.roles.includes("admin")
				}
			};
		},
        computed: {
            formSerialised() {
                return JSON.stringify(this.form);
            }
        }
	};
</script>
